import {createContext} from 'react'

const cacheRouterContext = createContext()

export default cacheRouterContext